export default __webpack_public_path__ + "static/media/logo-dark.2bf36a66.svg";